import {chatPanelMinWidth} from '@components/right-panel/right-panel/right-panel-store'

export const getTextRightPanelWidth = (width = 0): string => {
  const start = 450
  const offset = 50

  if (width <= 450) {
    return `${chatPanelMinWidth}-450`
  }

  const rest = width - start - 1
  const count = Math.floor(rest / offset)

  const from = start + count * offset
  return `${from + 1} - ${from + offset}`
}

export const getSizeInRange = (value = 0, offset = 100, start = 0): string => {
  const rest = value - start - 1
  const count = Math.floor(rest / offset)

  const from = start + count * offset
  return `${from + 1} - ${from + offset}`
}
